module.exports = __webpack_public_path__ + "media/joy-to-the-world_timothy-infinite.6249bf0b.mp3";